
export const environment = {
   production: true,
   base_url: "https://development.wingspark.eu",
   ws: "wss://development.wingspark.eu/ws",
   agm_key: "AIzaSyC5ppFKvqS6aQrKhD9br-Rs4t92yOoM6wM",
   environment: "test",
   name: "test"
};
